import { Box, Button, Dialog, Slide, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import React, { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatBox = ({ value, label, valueColor }) => (
  <Box sx={{ flex: 1, textAlign: "center", padding: "0 .5rem" }}>
    <Typography variant="h5" fontWeight="bold" color={valueColor}>
      {value}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

const PlanRow = ({ title, usedLabel, usedValue, remainingValue, resetDateLabel, daysUntilReset }) => (
  <Box sx={{ padding: ".5rem 0" }}>
    <Typography variant="subtitle2" fontWeight="bold" color="text.secondary" sx={{ marginBottom: ".25rem" }}>
      {title}
    </Typography>
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <StatBox value={usedValue} label={usedLabel} />
      <StatBox value={remainingValue} label="remaining" valueColor="error.main" />
      <StatBox value={resetDateLabel} label={`resets in ${daysUntilReset} days`} />
    </Box>
  </Box>
);

export default function PlanLimitModal({
  open,
  residentName,
  cost,
  count,
  resetDateLabel,
  daysUntilReset,
  handleClose,
}) {
  return (
    <Dialog open={open} onClose={() => handleClose(true)} TransitionComponent={Transition}>
      <Box sx={{ width: "420px" }}>
        <Box sx={{ padding: "1rem 1.5rem", backgroundColor: "#fdecea" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            <ErrorIcon color="error" sx={{ fontSize: "2rem" }}/>
            <Typography variant="h6" fontWeight="bold">
              Meal Plan Limit Reached
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ marginLeft: "2.5rem" }}>
            {residentName}
          </Typography>
        </Box>
        <Box sx={{ padding: "0 1rem" }}>
          {count && (
            <PlanRow
              title="Meal Count"
              usedLabel="meals used"
              usedValue={count.usedValue}
              remainingValue={count.remainingValue}
              resetDateLabel={resetDateLabel}
              daysUntilReset={daysUntilReset}
            />
          )}
          {count && cost && <Box sx={{ borderTop: "1px solid lightgray" }} />}
          {cost && (
            <PlanRow
              title="Meal Cost"
              usedLabel="plan limit"
              usedValue={cost.usedValue}
              remainingValue={cost.remainingValue}
              resetDateLabel={resetDateLabel}
              daysUntilReset={daysUntilReset}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", gap: "1rem", padding: "1.25rem 1rem" }}>
          <Button
            variant="contained"
            sx={{ flex: 1, fontWeight: "bold", color: "#FFF", backgroundColor: "var(--tealColor)" }}
            onClick={() => handleClose(true)}>
            ORDER ANYWAY
          </Button>
          <Button variant="outlined" sx={{ flex: 1, fontWeight: "bold" }} onClick={() => handleClose(false)}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}